import React from 'react';
import I18n from 'i18n-js';
import qs from 'qs';
import { CORE_WEB_ORIGIN } from '@reverbdotcom/env';
import { PASSWORD_RESET_PATH } from '../url_helpers';
import bind from '../bind';
import CsrfForm from '../csrf_form';
import { isDevSPA } from '../test_env_helper';
import FacebookSignin from './facebook_signin';
import { withUserContext, IUserContext } from './user_context_provider';
import { isExperimentEnabled } from '../user_context_helpers';
import experiments from '../experiments';

import {
  RCCheckbox,
  RCEmailInput,
  RCPasswordInput,
} from '../rc/forms';
import AppleSignInButton from './apple_signin_button';

interface IProps extends IUserContext {
  onToggle: { (event: any): void };
  redirectTo?: string;
  shouldRenderHeader?: boolean;
}

interface IState {
  rememberMe: boolean;
  email: string;
  password: string;
}

/** Auth URL for disco sandbox mode. Not used in production reverb-ui builds */
export const DEV_OAUTH_ROUTE = `${CORE_WEB_ORIGIN}/oauth/authorize?client_id=${process.env.DISCO_OAUTH_CLIENT_ID}&redirect_uri=${window.location.origin}/oauth_success&response_type=token&scope=read_listings+read_lists+write_lists+read_profile+write_profile+write_offers+read_offers+read_orders+read_addresses+write_addresses+unrestricted`;

export class SigninForm extends React.Component<IProps, IState> {
  static defaultProps: Partial<IProps> = {
    shouldRenderHeader: true,
  };

  state = {
    rememberMe: true,
    email: '',
    password: '',
  };

  @bind
  handleSubmit(e) {
    const rememberMeElem = e.target.elements['user_session[remember_me]'];
    rememberMeElem.value = this.state.rememberMe; // coerce this into a boolean
  }

  authUrlParams() {
    return qs.stringify({
      redirect_to: this.props.redirectTo,
    });
  }

  renderHeader() {
    if (!this.props.shouldRenderHeader) { return null; }

    return (
      <h4 className="signup-signin__header">
        {I18n.t('commons.signupForm.signinHeader')}
      </h4>
    );
  }

  loginButton() {
    if (isDevSPA(window.location.origin)) {
      return (
        <a className="button button--primary width-100" href={DEV_OAUTH_ROUTE}>
          {I18n.t('commons.signupForm.logIn')}
        </a>
      );
    }
    return (
      <input type="submit" value={I18n.t('commons.signupForm.logIn')} className="button button--primary width-100" />
    );
  }

  render() {
    return (
      <div>
        {this.renderHeader()}
        <CsrfForm
          action={`/authenticate?${this.authUrlParams()}`}
          method="post"
          onSubmit={this.handleSubmit}
          data-disable-auto-validation="true" // block forms.js handling
        >
          <RCEmailInput
            label={I18n.t('commons.signupForm.emailLabel')}
            id="signin--login"
            name="user_session[login]"
            value={this.state.email}
            onChange={(evt) => this.setState({ email: evt.target.value })}
            required
          />
          <RCPasswordInput
            label={I18n.t('commons.signupForm.passwordLabel')}
            id="signin--password"
            name="user_session[password]"
            required
            autoComplete="current-password"
            value={this.state.password}
            onChange={(evt) => this.setState({ password: evt.target.value })}
          />

          <div className="scaling-mtb-2">
            {this.loginButton()}
          </div>

          <RCCheckbox
            label={I18n.t('commons.signupForm.rememberMe')}
            id="signin--remember_me"
            name="user_session[remember_me]"
            onChange={() =>
              this.setState((prevState) => ({ rememberMe: !prevState.rememberMe }))
            }
            checked={this.state.rememberMe}
          />

          <p className="size-90 mt-1 align-center">
            {I18n.t('commons.signupForm.forgotPassword')}
            {' '}
            <a
              href={PASSWORD_RESET_PATH}
              target="_blank"
              rel="noopener noreferrer"
            >
              {I18n.t('commons.signupForm.passwordReset')}
            </a>
          </p>
        </CsrfForm>
        <hr className="mtb-2" />

        {isExperimentEnabled(this.props.user, experiments.APPLE_SIGN_IN_WEB) ?
          <AppleSignInButton redirectTo={this.props.redirectTo} />
          :
          <div className="signup-signin__form__facebook">
            <FacebookSignin redirectTo={this.props.redirectTo} />
          </div>
        }
      </div>
      
    );
  }
}
export default withUserContext(SigninForm);
